import React, { useEffect, useState } from "react";
import { LeadTypeIdEnum } from "../../Enums";
import { GetContactById } from "../../Services";
import SelectLeadTypeDialog from "./components/SelectLeadTypeDialog";
import { ContactsMapper } from "../../Views/Home";
import { DialogComponent } from "../DialogComponent/DialogComponent";
import ContactAndLeadInfo from "./components/ContactAndLeadInfo";
import { CustomDialog, CustomSelectLeadType } from "../V2";
import SeekerLeadForm from "./components/SeekerLeadForm";
import OwnerLeadForm from "./components/OwnerLeadForm";
import CreateLeadContextProvider from "./context/CreateLeadContext";
import { useLayoutDetection } from "../../Hooks";
import { showError } from "../../Helper";

import useStyles from "./styles";

const dialogTitle = {
  [LeadTypeIdEnum.Seeker.leadTypeId]: "Add seeker lead - Contact & Meta",
  [LeadTypeIdEnum.Owner.leadTypeId]: "Add owner lead - Contact & Meta",
};
const dialogContent = {
  [LeadTypeIdEnum.Seeker.leadTypeId]: SeekerLeadForm,
  [LeadTypeIdEnum.Owner.leadTypeId]: OwnerLeadForm,
};
const CreateLeadDialog = ({ open, setOpen, contactId }) => {
  const [leadType, setLeadType] = useState(null);
  const [contact, setContact] = useState(null);
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const styles = useStyles();
  const isNewLayout = isReskinningLayout && hasNewLayout;
  const getContactById = async () => {
    try {
      const res = await GetContactById(contactId);
      if (res) {
        const mappedContact = ContactsMapper(res, JSON.parse(res.contactJson));
        setContact(mappedContact);
      }
    } catch {
      showError("error_getting_contact");
    }
  };

  const onCloseClick = () => {
    setOpen(false);
    setLeadType(null);
  };
  const ActiveContent = dialogContent[leadType];
  useEffect(() => {
    if (contactId) {
      getContactById();
    }
  }, [contactId]);
  if (!open) return null;

  if (isNewLayout) {
    return (
      <CreateLeadContextProvider>
        {leadType ? (
          <CustomDialog
            open={open}
            title={dialogTitle[leadType]}
            onClose={onCloseClick}
            paperClassName={styles.dialogWrapper}
            content={
              <div>
                <ContactAndLeadInfo contact={contact} />
                <ActiveContent onClose={onCloseClick} contact={contact} />
              </div>
            }
            showActions={false}
          />
        ) : (
          <CustomSelectLeadType
            onLeadTypeSelect={setLeadType}
            open
            setOpen={setOpen}
          />
        )}
      </CreateLeadContextProvider>
    );
  }

  return (
    <CreateLeadContextProvider>
      {leadType ? (
        <DialogComponent
          isOpen={open}
          titleText={dialogTitle[leadType]}
          onCloseClicked={onCloseClick}
          dialogContent={
            <div>
              <ContactAndLeadInfo contact={contact} />
              <ActiveContent onClose={onCloseClick} contact={contact} />
            </div>
          }
        />
      ) : (
        <SelectLeadTypeDialog
          onLeadTypeSelect={setLeadType}
          open
          setOpen={setOpen}
        />
      )}
    </CreateLeadContextProvider>
  );
};
export default CreateLeadDialog;
